import { Link } from "react-router-dom";

export default function TermsConditionsPage() {
  return (
    <div>
      {/* Hero Section */}
      <section className="py-16 bg-slate-900">
        <div className="container-custom">
          <h1 className="heading-primary text-white mb-4" data-testid="terms-title">
            Terms & Conditions
          </h1>
          <p className="text-slate-400">Last updated: January 2024</p>
        </div>
      </section>

      {/* Content */}
      <section className="section-padding bg-white" data-testid="terms-content">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto prose prose-slate prose-lg">
            <h2 className="heading-tertiary text-slate-900">1. Agreement to Terms</h2>
            <p className="text-slate-600 mb-8">
              By accessing or using BuyVistas's website and services, you agree to be bound by these 
              Terms and Conditions. If you disagree with any part of these terms, you may not access 
              our services.
            </p>

            <h2 className="heading-tertiary text-slate-900">2. Services</h2>
            <p className="text-slate-600 mb-8">
              BuyVistas provides professional pressure washing services for residential and commercial 
              properties. Our services include but are not limited to house washing, driveway cleaning, 
              deck and patio cleaning, roof cleaning, and commercial pressure washing.
            </p>

            <h2 className="heading-tertiary text-slate-900">3. Service Quotes and Pricing</h2>
            <p className="text-slate-600 mb-4">
              All quotes provided are estimates based on the information provided to us. Final pricing 
              may vary based on:
            </p>
            <ul className="list-disc pl-6 text-slate-600 mb-8">
              <li>Actual condition of the property upon inspection</li>
              <li>Additional services requested</li>
              <li>Unforeseen circumstances or complications</li>
              <li>Size and accessibility of the area to be cleaned</li>
            </ul>

            <h2 className="heading-tertiary text-slate-900">4. Scheduling and Cancellation</h2>
            <p className="text-slate-600 mb-4">
              Service appointments are scheduled based on availability. We require:
            </p>
            <ul className="list-disc pl-6 text-slate-600 mb-8">
              <li>24-hour notice for cancellations to avoid a cancellation fee</li>
              <li>Access to water and electrical outlets at the property</li>
              <li>Clear access to all areas to be serviced</li>
            </ul>

            <h2 className="heading-tertiary text-slate-900">5. Payment Terms</h2>
            <p className="text-slate-600 mb-8">
              Payment is due upon completion of services unless otherwise agreed in writing. We accept 
              major credit cards, checks, and cash. For commercial accounts, net-30 payment terms may 
              be arranged upon approval.
            </p>

            <h2 className="heading-tertiary text-slate-900">6. Satisfaction Guarantee</h2>
            <p className="text-slate-600 mb-8">
              We stand behind our work with a 100% satisfaction guarantee. If you're not completely 
              satisfied with our service, please contact us within 48 hours of service completion, 
              and we will re-clean the area at no additional charge.
            </p>

            <h2 className="heading-tertiary text-slate-900">7. Liability and Insurance</h2>
            <p className="text-slate-600 mb-8">
              BuyVistas is fully licensed and insured. While we take every precaution to prevent 
              damage, we are not liable for pre-existing conditions, normal wear and tear revealed 
              by cleaning, or damage caused by factors beyond our control. Any claims for damage 
              must be reported within 24 hours of service completion.
            </p>

            <h2 className="heading-tertiary text-slate-900">8. Property Access and Preparation</h2>
            <p className="text-slate-600 mb-4">Customers are responsible for:</p>
            <ul className="list-disc pl-6 text-slate-600 mb-8">
              <li>Providing clear access to the service areas</li>
              <li>Removing or securing loose items and personal belongings</li>
              <li>Closing all windows and doors before service</li>
              <li>Securing pets during the service</li>
              <li>Informing us of any known hazards or special conditions</li>
            </ul>

            <h2 className="heading-tertiary text-slate-900">9. Weather Conditions</h2>
            <p className="text-slate-600 mb-8">
              Services may be rescheduled due to inclement weather conditions. We will make every 
              effort to reschedule at the earliest convenient time. Weather-related rescheduling 
              will not incur any additional fees.
            </p>

            <h2 className="heading-tertiary text-slate-900">10. Intellectual Property</h2>
            <p className="text-slate-600 mb-8">
              All content on this website, including text, graphics, logos, and images, is the 
              property of BuyVistas and is protected by copyright laws. You may not reproduce, 
              distribute, or create derivative works without our express written consent.
            </p>

            <h2 className="heading-tertiary text-slate-900">11. Limitation of Liability</h2>
            <p className="text-slate-600 mb-8">
              To the maximum extent permitted by law, BuyVistas shall not be liable for any indirect, 
              incidental, special, consequential, or punitive damages resulting from your use of our 
              services or this website.
            </p>

            <h2 className="heading-tertiary text-slate-900">12. Changes to Terms</h2>
            <p className="text-slate-600 mb-8">
              We reserve the right to modify these Terms and Conditions at any time. Changes will be 
              effective immediately upon posting on our website. Your continued use of our services 
              constitutes acceptance of any modified terms.
            </p>

            <h2 className="heading-tertiary text-slate-900">13. Governing Law</h2>
            <p className="text-slate-600 mb-8">
              These Terms and Conditions shall be governed by and construed in accordance with the 
              laws of the State of New York, without regard to its conflict of law provisions.
            </p>

            <h2 className="heading-tertiary text-slate-900">14. Contact Information</h2>
            <p className="text-slate-600 mb-4">
              For questions about these Terms and Conditions, please contact us:
            </p>
            <ul className="list-none text-slate-600 mb-8">
              <li><strong>Email:</strong> support@buyvistas.store</li>
              <li><strong>Phone:</strong> +1-888-435-4674</li>
              <li><strong>Address:</strong> 20 E 22nd St #4699, New York, NY 10165</li>
            </ul>

            <div className="mt-12 pt-8 border-t border-slate-200">
              <Link to="/" className="text-sky-600 hover:text-sky-700 font-semibold">
                ← Back to Home
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
